import Modal from 'bootstrap/js/dist/modal';
document.addEventListener('DOMContentLoaded', () => {
    const speakers = document.querySelectorAll('.painelista-lista ul li a');

    const createModal = ( id ) => {
        fetch(siteData.siteUrl + '/wp-json/conec/v1/mini-bio' + '?id=' + id + '&nonce=' + siteData.nonce)
            .then(response => response.json())
            .then(data => {
                const modal = document.createElement('div');
                modal.classList.add('modal');
                modal.setAttribute('tabindex', '-1');
                modal.innerHTML = `
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content bg-primary">
                            <div class="modal-header border-0">
                                <button type="button" class="btn-close rounded-circle text-white opacity-100 p-0 fs-5" data-bs-dismiss="modal" aria-label="Close" style="background: none !important;">X</button>
                            </div>
                            <div class="modal-body pt-0">
                              <h5 class="modal-title text-secondary ps-5">${data.title}</h5>
                              <p class="mb-3 small text-white px-5">${data.bio}</p>
                              <p class="${ '' === data.linkedin ? 'd-none' : '' } text-end">
                                  <a href="${data.linkedin}" target="_blank" class="text-primary">
                                    <img src="${siteData.siteUrl}/wp-content/themes/sincor-conec/assets/images/icon-linkedin.svg" width="24" height="24" alt="">
                                  </a>
                              </p>
                            </div>
                        </div>
                    </div>
                `;
                document.body.appendChild(modal);

                const speakerModal = new Modal(modal);
                speakerModal.show();
            })
            .catch(error => console.error('Error creating post:', error));
    }

    speakers.forEach( ( speaker ) => {
        speaker.addEventListener('click', ( e ) => {
            e.preventDefault();
            createModal( e.target.getAttribute('rel') );
        })
    })
})